import React from 'react';
import "./filter.scss";
import Dropdown from '../../common/dropdown-v2/dropdown';
import DropdownV4 from '../../common/dropdown-v4/dropdown';

import SchoolApi from '../../../apis/school'
import MasterDataApi from '../../../apis/master-data'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';


class FilterComponent extends React.Component {

    state = {
        showShadow: false,
        showFilters: true,
        disableGo: true,

        boardsDropdownItems: [],
        classDropdownItems: [],
        mediumDropdown: [],

        chapterDropDownItems: [],
        teachersDropDownItems: [],
        selectedBoard: "",
        selectedClass: "",
        selectedChapterKey: [],
        selectedTeachersId: [],
        eloDropdownItems: [],
        disableClass: true,
        disableChapters: true,
        selectedStandardHomeworkId: '',
        streamingDropdown: [{ title: "Default", value: "DEFAULT" }, { title: "Previous Year Mark", value: "PREVIOUS_YEAR_MARK" }],


        schoolsListDropdown: []
    }

    classSectionHash = {}
    conceptHash = {}
    eloHash = {}


    constructor(props) {
        super(props)
    }


    componentDidMount() {
        //  this.getClasses()
        this.getJigyasaSchoolsList()
    };


    getJigyasaSchoolsList() {

        let payload = {}

        SchoolApi.getJigyasaSchools(payload).then(res => {
            console.log(res)

            let schoolsListDropdown = []

            if (res.response.length) {

                for (let i = 0; i < res.response.length; i++) {
                    schoolsListDropdown.push({
                        title: res.response[i].name,
                        value: res.response[i].schoolCode,
                        classList: res.response[i].classes,
                        boardList: res.response[i].board,
                        mediumList: res.response[i].medium
                    })
                }
            }

            this.setState({ schoolsListDropdown: schoolsListDropdown })

        }).catch(err => {
            console.log(err)
        })
    }

    getClassesForJigyasaSchool(school) {

        // SchoolApi.getClassAndBoardForJigyasaSchool(payload)
        //     .then(school => {
        console.log(school)
        let classes = [], boards = [], mediumDropdown = [];
        for (let i = 0; i < school.classList.length; i++) {
            classes.push({
                title: school.classList[i].name,
                value: school.classList[i].name,
            })
        }

        for (let i = 0; i < school.boardList.length; i++) {
            boards.push({
                title: school.boardList[i].name,
                value: school.boardList[i].name,
            })
        }

        for (let i = 0; i < school.mediumList.length; i++) {
            mediumDropdown.push({
                title: school.mediumList[i].name,
                value: school.mediumList[i].name,
            })
        }

        if (boards.length > 1) {
            this.setState({ boardsDropdownItems: boards })
        } else {
            this.setState({ selectedBoard: school?.boardList[0]?.name })
        }
        this.setState({ classDropdownItems: classes, mediumDropdown })
        // }).catch(err => {
        // })
    }




    getSections(payload = {}) {

        if (!payload.selectedSchoolId) payload.schoolId = this.state.selectedSchoolId
        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.selectedBoard

        if (!payload.class || !payload.board) {
            this.setState({ sectionDropdownItems: [], selectedSection: "" })
            this.reloadDropdown()
            return
        }

        SchoolApi.getSectionsForJigyasaSchool(payload)
            .then(response => {
                let sections = []
                // console.log(response)
                for (let i = 0; i < response.response.length; i++) {

                    if (response.response[i].section !== 'No Sections') {
                        sections.push({
                            title: response.response[i].section,
                            value: response.response[i]._id,
                            sectionId: response.response[i]._id
                        })
                    }


                }
                this.classSectionHash[payload.class] = sections
                this.setState({ sectionDropdownItems: sections, selectedSection: "" })
                this.reloadDropdown()
            }).catch(err => {
                this.setState({ sectionDropdownItems: [], selectedSection: "" })
                this.reloadDropdown()
            })
    }

    getChapters(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.selectedBoard

        if (this.state.isFromPk) {
            payload.addNotShowInSchoolChaptersForPK = true
        }

        MasterDataApi.getChapterList(payload)
            .then(response => {
                let chapters = []
                response = response.data
                this.setState({ masterDataId: response._id })
                for (let i = 0; i < response.chapters.length; i++) {
                    let chapter = response.chapters[i], concepts = []
                    chapters.push({
                        title: chapter.title,
                        value: chapter.key,
                    })



                    for (let j = 0; j < chapter.concepts?.length; j++) {
                        let concept = chapter.concepts[j]
                        concepts.push({
                            title: concept.title,
                            value: concept.key,
                            order: j + 1
                        })
                        // this.buildElosDropdown(concept)
                    }
                    this.conceptHash[chapter.key] = concepts

                }

                this.conceptAndChapterKeyHash = {}

                if (this.state.isFromPk) {

                    let hash = this.getChapterKeyForConceptKey()

                    console.log(this.conceptHash)


                    for (let i = 0; i < response.chapters.length; i++) {
                        let chapter = response.chapters[i]
                        console.log(this.conceptHash[this.getChapterKeyForPk()])
                        this.conceptHash[this.getChapterKeyForPk()].forEach(concept => {

                            concept.baseChapterKey = hash[concept.value]

                            // if (concept.title === chapter.title) {
                            //     // Origion Chapter Key
                            //     this.conceptAndChapterKeyHash[concept.value] = chapter.key
                            // }

                        })
                    }
                }

                // console.log(this.conceptAndChapterKeyHash)

                this.setState({ chapterDropDownItems: chapters, selectedElo: "" })
                this.reloadDropdown()
            }).catch(err => {
            })
    }

    getChapterKeyForConceptKey() {

        let hash = {}

        switch (this.state.selectedClass) {
            case 'Class 6':
                hash = {
                    "16533837374847142": "15845131996920700",
                    "16533858012107294": "15856473964482771",
                    "16533859537866169": "15857164729919834",
                    "16533860794669673": "15857164976853655",
                    "16533862257725123": "15857165495906003",
                    "16533863628124282": "15857165661650098",
                    "16533867311374147": "15857165848090445",
                    "16533868102843285": "15857166094719563",
                    "16533868829612973": "15857166437420553",
                    "16533869787154165": "15857166644378707"
                };
                break;
            case 'Class 7':
                hash = {
                    "16533871621566975": "15845144070966249",
                    "16533881394545621": "15856360518110730",
                    "16533883752772603": "15856361122223503",
                    "16533885081008251": "15856361208264022",
                    "16533886374021934": "15856361345562753",
                    "16533887891449037": "15856361596729330",
                    "16533895225638602": "15856361627495437",
                    "16533902524652201": "15856361652486357",
                    "16533907111994765": "15856361747031712",
                    "16533909564324035": "15856361811697076",
                    "16533914238938593": "15856362701104974",
                    "16533915422089716": "15856362826362665",
                    "16533916030612908": "15856363000898741",
                    "16533916081672939": "15856363107929523"
                };
                break;
            case 'Class 8':
                hash = {
                    "16533928739794336": "15857337683614007",
                    "16533934346894248": "15868832020204343",
                    "16533935529353288": "15873071841353333",
                    "16533939949709566": "15873072185461315",
                    "16533950094755221": "15873072390168173",
                    "16533962077391457": "15873072479404585",
                    "16533975927102829": "15873072632957093",
                    "16533977231750042": "15873072719086513",
                    "16533979369062274": "15873072822706766",
                    "16533982570657139": "15873073030008444"
                };
                break;
            case 'Class 9':
                hash = {
                    "16534518035374484": "16252167032887549",
                    "16534518235596193": "16255594624435369",
                    "16534518732721148": "16255595864935652",
                    "16534518933521005": "16255596084001110",
                    "16534518940551071": "16255596226781160",
                    "16534519476447793": "16255597711777661",
                    "16534519779433487": "16255597874627555"
                };
                break;
            default:
                hash = {
                    "16533837374847142": "15845131996920700",
                    "16533858012107294": "15856473964482771",
                    "16533859537866169": "15857164729919834",
                    "16533860794669673": "15857164976853655",
                    "16533862257725123": "15857165495906003",
                    "16533863628124282": "15857165661650098",
                    "16533867311374147": "15857165848090445",
                    "16533868102843285": "15857166094719563",
                    "16533868829612973": "15857166437420553",
                    "16533869787154165": "15857166644378707"
                }
                break;
        }

        return hash

    }

    sortPayload(nodes) {
        let orderedList = [];
        let workFlowNodeHash = {};
        let startingNode;

        for (let i = 0; i < nodes.length; i++) {

            let nodeId = nodes[i]._id.toString();

            if (nodes[i].previousNode == null)
                startingNode = nodeId;

            workFlowNodeHash[nodeId] = nodes[i];
        }

        let tempNode = startingNode;

        for (let i = 0; i < nodes.length; i++) {
            if (tempNode) {
                orderedList.push(workFlowNodeHash[tempNode]);
                tempNode = workFlowNodeHash[tempNode]?.nextNode;
            }
        }
        return orderedList
    }


    getChapterKeyForPk() {

        let chapterKey = ''

        switch (this.state.selectedClass) {
            case 'Class 6':
                chapterKey = '16533836874781844';
                break;
            case 'Class 7':
                chapterKey = "16533871579715896";
                break;
            case 'Class 8':
                chapterKey = "16533917931207385";
                break;
            case 'Class 9':
                chapterKey = "16534517911704106";
                break;
            default:
                chapterKey = '16533836874781844';
                break;

        }

        return chapterKey
    }


    getWorkflowNodes(payload = {}) {
        payload = {
            class: this.state.selectedClass,
            board: this.state.selectedBoard,
            chapterKey: this.state.selectedChapterKey,
            masterDataId: this.state.masterDataId
        }


        if (this.state.isFromPk) {
            payload.chapterKey = this.getChapterKeyForPk()
        }


        MasterDataApi.getWorkflowNodes(payload)
            .then(response => {
                response = response.data
                console.log(response)
                this.eloHash = {}
                for (let i = 0; i < response.length; i++) {
                    let chapter = response[i], elos = []

                    for (let j = 0; j < chapter.elos?.length; j++) {
                        let elo = chapter.elos[j]
                        elos.push({
                            title: elo.title,
                            value: elo.id,
                            conceptTitle: chapter.conceptTitle,
                            conceptValue: chapter.conceptKey,
                            skill: elo.skill?.title
                        })
                    }
                    if (this.eloHash[chapter.conceptKey]) {
                        this.eloHash[chapter.conceptKey].push(...elos)
                    } else {
                        this.eloHash[chapter.conceptKey] = elos
                    }
                }

                let eloList = this.sortPayload(response)
                this.setState({ orderedEloList: eloList })
            }).catch(err => {
            })
    }

    buildElosDropdown(concept) {
        let elos = []
        for (let i = 0; i < concept?.subConcepts?.length; i++) {
            let subConcept = concept.subConcepts[i]
            for (let j = 0; j < subConcept.elo?.length; j++) {
                let elo = subConcept.elo[j]
                elos.push({
                    title: elo.title,
                    value: elo.eloId,
                    conceptTitle: concept.title,
                    conceptValue: concept.key
                })
            }

        }
        this.eloHash[concept.key] = elos
        return
    }

    reloadDropdown() {
        this.setState({ reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
    }

    resetDropDowns(callback) {
        this.setState({
            selectedBoardId: "",
            selectedClassId: "",
            chapterDropdownItems: [],
        }, () => { if (callback) callback(); });
    }


    onGo() {
        let payload = {
            board: this.state.selectedBoard,
            class: this.state.selectedClass,
            chapterKey: this.state.selectedChapterKey,
            assignedTo: this.state.selectedTeachersId
        };
        if (this.props.onGo) {
            this.props.onGo(payload)
        }
    }

    refreshPage() {
        this.setState(
            { reload: true },
            () => this.setState({ reload: false })
        )
    }

    toggleFilters = () => {
        this.setState({ showFilters: !this.state.showFilters })
    }

    onSelectDropDown = (option, key) => {
        console.log(option, key)
        this.setState({ [key]: option?.value, }, () => {
            this.props.delegate && this.props.delegate.resetErrorMessages && this.props.delegate.resetErrorMessages()


            if (key == 'selectedSchoolId') {
                this.getClassesForJigyasaSchool(option)
            }


            if (key == "selectedClass" || key == "selectedBoard") {
                this.getSections()
                // this.getChapters()
            }

            if (key == 'selectedSection') {
                // console.log(option.sectionId)
                this.setState({ [key]: option?.sectionId, sectionName: option?.title })
            }


            if (key == 'selectedMedium') {
                // console.log(option.sectionId)
                // this.setState({ [key]: option?.sectionId, sectionName: option?.title })
            }


            this.emitChanges(key == "selectedClass" || key == "selectedBoard" || key == 'selectedSection' || key == "selectedMedium")
        })
    }

    onMultiSelectDropdown = (options, key) => {
        console.log(options)

        if (this.state.isFromPk) {
            options = [{ value: this.state.pkConceptKey, order: 1 }]
        }

        this.props.delegate && this.props.delegate.resetErrorMessages && this.props.delegate.resetErrorMessages()
        let value = [], eloDropdownItems = [], conceptList = [], skillDropdownItems = [], skillHash = {}
        options = options.sort((a, b) => a.order - b.order)
        console.log(this.eloHash)

        for (let i = 0; i < options.length; i++) {
            let option = options[i]
            value.push(option?.value)

            if (key == "selectedConcept") {
                if (this.eloHash[option?.value]) {

                    let eloContruct = []
                    let elo = this.eloHash[option?.value]
                    let elos = elo.map((e) => {

                        if (!skillHash[e.skill]) {
                            skillHash[e.skill] = true
                            skillDropdownItems.push({ title: e.skill, value: e.skill })
                        }

                        eloContruct.push({ id: e.value })
                        return {
                            ...e,
                            conceptName: `Concept ${i + 1}`
                        }
                    })
                    eloDropdownItems.push(...elos)

                    conceptList.push({
                        key: option?.value,
                        elos: eloContruct
                    })
                }
            }
        }

        console.log(conceptList)



        this.setState({ reloadDropdown: true, reloadConceptDropdown: true, eloDropdownItems, skillDropdownItems, [key]: value, conceptList, conceptsArray: conceptList }, () => {
            this.props.isAdaptive && key == "selectedConcept" && this.props.delegate?.handleEloDropdown && this.props.delegate.handleEloDropdown(eloDropdownItems, skillDropdownItems, conceptList)
            this.setState({ reloadDropdown: false, reloadConceptDropdown: false, selectedElo: "" })
            this.emitChanges()
        })
    }


    onSelectElo = (options) => {
        let groupByConcept = {}
        let conceptList = []

        for (let i = 0; i < options.length; i++) {
            let option = options[i]

            if (!groupByConcept[option?.conceptValue])
                groupByConcept[option.conceptValue] = { key: option.conceptValue, elos: [{ id: option?.value }] }
            else
                groupByConcept[option.conceptValue].elos.push({
                    id: option?.value
                })
        }

        // let conceptKeys = Object.keys(groupByConcept)

        let conceptKeys = []

        for (let i = 0; i < this.state.conceptsArray.length; i++) {

            conceptKeys.push(this.state.conceptsArray[i].key)

        }

        for (let i = 0; i < conceptKeys.length; i++) {

            let key = conceptKeys[i]
            if (groupByConcept[key]) {
                conceptList.push({
                    key,
                    elos: groupByConcept[key].elos
                })
            }
        }

        let values = options.map(option => option?.value)
        // let result = []
        // for (let i = 0; i < this.state.orderedEloList?.length; i++) {
        //     let eloId = this.state.orderedEloList[i]?.elos[0]?.id
        //     if (values.includes(eloId)) {
        //         result.push(eloId)
        //     }
        // }

        this.setState({ selectedElo: values, conceptList }, () => {
            this.emitChanges()
        })
    }

    handleDateEvent = (event, picker) => {
        this.props.delegate && this.props.delegate.resetErrorMessages && this.props.delegate.resetErrorMessages()
        this.startDate = picker.startDate
        this.setState({ selectedDate: new Date(picker.startDate).toLocaleDateString() });
        this.emitChanges(true)
    }


    emitChanges(reloadQuestions) {
        //console.log('chapter filter called')

        let payload = {
            schoolId: this.state.selectedSchoolId,
            board: this.state.selectedBoard,
            class: this.state.selectedClass,
            section: this.state.sectionName,
            sectionId: this.state.selectedSection,
            medium: this.state.selectedMedium,
            // chapter: this.state.selectedChapterKey,
            // concepts: this.state.selectedConcept,
            // elos: this.state.selectedElo,
            dueDate: this.startDate ? (new Date(new Date(this.startDate).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1) : '',
            // masterDataId: this.state.masterDataId,
            // conceptList: this.state.conceptList,
            // homeworkId: this.state.selectedStandardHomeworkId || this.state.recommendationReportHomeworkId,
        }




        if (this.props.onGo) {
            this.props.onGo(payload, reloadQuestions)
        }
    }

    render() {

        return (

            <div className="new-homwwork-filter-for-assessment">
                {
                    !this.state.reload ?
                        <div className={this.state.showFilters ? "filter-content" : "filter-content d-none"} >
                            <div className="row">
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Schools<span className='text-danger'>*</span>
                                    </div>
                                    <div className={this.props.isCreate && !this.state.selectedSchoolId ? 'error-border' : ''}>
                                        {!this.state.reloadDropdown ?
                                            <Dropdown
                                                placeholder='Select a School'
                                                options={this.state.schoolsListDropdown}
                                                onSelect={(option) => this.onSelectDropDown(option, "selectedSchoolId")}
                                                text={"title"}
                                                value={this.state.selectedSchoolId}

                                            /> : ''}
                                    </div>
                                    {this.props.isCreate && !this.state.selectedSchoolId ? <div className='error-text text-danger'>Please Select a School</div> : ''}
                                </div>
                                {
                                    this.state.boardsDropdownItems.length > 1 ?
                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                            <div className="filter-input-label">
                                                Board<span className='text-danger'>*</span>
                                            </div>
                                            <div className={this.props.isCreate && !this.state.selectedBoard ? 'error-border' : ''}>
                                                <Dropdown
                                                    placeholder='Select a board'
                                                    options={this.state.boardsDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                                    text={"title"}
                                                    value={this.state.selectedBoard}

                                                />
                                            </div>
                                            {this.props.isCreate && !this.state.selectedBoard ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                                        </div>
                                        : ""
                                }
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Class<span className='text-danger'>*</span>
                                    </div>
                                    <div className={this.props.isCreate && !this.state.selectedClass ? 'error-border' : ''}>
                                        {!this.state.reloadDropdown ?
                                            <Dropdown
                                                placeholder='Select a Class'
                                                options={this.state.classDropdownItems}
                                                onSelect={(option) => this.onSelectDropDown(option, "selectedClass")}
                                                text={"title"}
                                                value={this.state.selectedClass}

                                            /> : ''}
                                    </div>
                                    {this.props.isCreate && !this.state.selectedClass ? <div className='error-text text-danger'>Please Select a class</div> : ''}
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Section<span className='text-danger'>*</span>
                                    </div>
                                    <div >
                                        {
                                            !this.state.reloadDropdown ?
                                                <Dropdown
                                                    key="class"
                                                    placeholder='Select a Section'
                                                    options={this.state.sectionDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedSection")}
                                                    text={"title"}
                                                    value={this.state.selectedSection}
                                                >
                                                </Dropdown>
                                                : ""
                                        }
                                    </div>
                                    {this.props.isCreate && !this.state.section ? <div className='error-text text-danger'>Please Select a Section</div> : ''}
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Medium<span className='text-danger'>*</span>
                                    </div>
                                    <div className={this.props.isCreate && !this.state.selectedMedium ? 'error-border' : ''}>
                                        {!this.state.reloadDropdown ?
                                            <Dropdown
                                                placeholder='Select a Medium'
                                                options={this.state.mediumDropdown}
                                                onSelect={(option) => this.onSelectDropDown(option, "selectedMedium")}
                                                text={"title"}
                                                value={this.state.selectedMedium}

                                            /> : ''}
                                    </div>
                                    {this.props.isCreate && !this.state.selectedMedium ? <div className='error-text text-danger'>Please Select a Medium</div> : ''}
                                </div>


                                {/* <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Due Date<span className='text-danger'>*</span>
                                    </div>
                                    <div className={this.props.isCreate && !this.state.selectedDate ? 'error-border' : ''}>
                                        <DateRangePicker onHide={this.handleDateEvent} onCancel={() => { }}
                                            autoApply={true}
                                            initialSettings={{ singleDatePicker: true, startDate: this.startDate, minDate: this.startDate ? this.startDate : new Date(), autoUpdateInput: false }}
                                            locale={{
                                                'format': 'DD/MM/YYYY'
                                            }}

                                        ><input className={`cw-input ${!this.props.selectDueDateMessage ? 'bg-white' : ""} `} placeholder="Select date" value={this.state.selectedDate} ></input>
                                        </DateRangePicker>
                                    </div>
                                    {this.props.isCreate && !this.state.selectedDate ? <div className='error-text text-danger'>Please Select a due date</div> : ''}
                                </div> */}
                            </div>
                        </div> : ""

                }
            </div>


        );
    }

}

export default FilterComponent;